"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var text_exports = {};
__export(text_exports, {
  boundsRuleDefaultMessage: () => boundsRuleDefaultMessage,
  requiredRuleDefaultMessage: () => requiredRuleDefaultMessage,
  timestampBoundsRuleDefaultMessage: () => timestampBoundsRuleDefaultMessage
});
module.exports = __toCommonJS(text_exports);
var import_types = require("@cartographerio/types");
function requiredRuleDefaultMessage(level) {
  return level === "error" ? "You must specify a value." : "You should specify a value.";
}
function defaultBoundsMessage(level, minValue, maxValue, valueDescription, format, messages) {
  const desc = valueDescription ?? "The value";
  const greater = messages === "timestamp" ? "later" : "greater";
  const less = messages === "timestamp" ? "earlier" : "less";
  if (minValue != null && maxValue != null) {
    if (minValue === maxValue) {
      return level === "error" ? `${desc} must be ${format(minValue)}.` : `${desc} should be ${format(minValue)}.`;
    } else {
      return level === "error" ? `${desc} must be between ${format(minValue)} and ${format(maxValue)}.` : `${desc} should be between ${format(minValue)} and ${format(maxValue)}.`;
    }
  } else if (minValue != null) {
    return level === "error" ? `${desc} must be ${format(minValue)} or ${greater}.` : `${desc} should be ${format(minValue)} or ${greater}.`;
  } else if (maxValue != null) {
    return level === "error" ? `${desc} must be ${format(maxValue)} or ${less}.` : `${desc} should be ${format(maxValue)} or ${less}.`;
  } else {
    return `${desc} can be any value.`;
  }
}
function boundsRuleDefaultMessage(level, minValue, maxValue, valueDescription) {
  return defaultBoundsMessage(level, minValue, maxValue, valueDescription, String, "number");
}
function timestampBoundsRuleDefaultMessage(level, minValue, maxValue, validateTime, valueDescription, now = (0, import_types.nowTimestamp)()) {
  return defaultBoundsMessage(
    level,
    minValue,
    maxValue,
    valueDescription,
    (ts) => (0, import_types.formatTimestamp)(ts === "now" ? now : ts, {
      format: validateTime ? import_types.defaultTimestampFormat : import_types.ddmmyyyy
    }),
    "timestamp"
  );
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  boundsRuleDefaultMessage,
  requiredRuleDefaultMessage,
  timestampBoundsRuleDefaultMessage
});
//# sourceMappingURL=text.js.map
